import React from "react";

const MONTH_NAMES = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December"
];

function formatDate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

function getCalendarGrid(currentDate) {
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const firstDay = new Date(year, month, 1).getDay();
  const totalDays = new Date(year, month + 1, 0).getDate();

  const cells = [
    ...Array(firstDay).fill(null),
    ...Array.from({ length: totalDays }, (_, i) => new Date(year, month, i + 1)),
  ];
  while (cells.length % 7 !== 0) cells.push(null);

  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));
  return weeks;
}

function getWeekTotal(week, map) {
  let total = 0, trades = 0;
  for (const day of week) {
    if (!day) continue;
    const d = map[formatDate(day)];
    if (d) { total += Number(d.total || 0); trades += Number(d.trade_count || 0); }
  }
  return { total, trades };
}

function fmt(total) {
  return `${total >= 0 ? "+" : "-"}$${Math.abs(total).toFixed(2)}`;
}

function TradingCalendar({ currentDate, setCurrentDate, calendarDays, selectedDate, onDayClick }) {
  const weeks = getCalendarGrid(currentDate);
  const map = {};
  for (const d of calendarDays) map[d.date] = d;

  return (
    <div className="calendar-wrapper">
      <div className="calendar-header">
        <div>
          <h2>{MONTH_NAMES[currentDate.getMonth()]} {currentDate.getFullYear()}</h2>
          <p className="page-subtitle" style={{ fontSize: "13px", marginTop: "4px" }}>
            Click a day to load the full review.
          </p>
        </div>
        <div className="calendar-controls">
          <button onClick={() => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1))}>{"<"}</button>
          <button onClick={() => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1))}>{">"}</button>
        </div>
      </div>

      {/* Horizontal scroll wrapper so calendar never breaks on small screens */}
      <div className="calendar-scroll-inner">
        <div className="calendar-grid-header">
          {["Sun","Mon","Tue","Wed","Thu","Fri","Sat","Weekly"].map(d => <div key={d}>{d}</div>)}
        </div>

        {weeks.map((week, wi) => {
          const weekly = getWeekTotal(week, map);
          return (
            <div className="calendar-week-row" key={wi}>
              {week.map((day, di) => {
                if (!day) return <div className="calendar-cell empty-cell" key={di} />;

                const ds = formatDate(day);
                const data = map[ds];
                const total = data ? Number(data.total || 0) : 0;
                const count = data ? Number(data.trade_count || 0) : 0;

                let cls = "calendar-cell neutral-day";
                if (data) cls = `calendar-cell ${total > 0 ? "green-day" : total < 0 ? "red-day" : "neutral-day"}`;
                if (selectedDate === ds) cls += " selected-day";

                return (
                  <div className={cls} key={di} onClick={() => onDayClick(ds)}>
                    <div className="day-number">{day.getDate()}</div>
                    {data ? (
                      <div className="day-info">
                        <div className={`day-amount ${total >= 0 ? "green-text" : "red-text"}`}>{fmt(total)}</div>
                        <div className="small-muted">{count} trades</div>
                      </div>
                    ) : (
                      <div className="small-muted no-trades">No trades</div>
                    )}
                  </div>
                );
              })}

              <div className={`weekly-box ${weekly.total >= 0 ? "green-weekly" : "red-weekly"}`}>
                <div className="weekly-title">Weekly</div>
                <div className={`weekly-amount ${weekly.total >= 0 ? "green-text" : "red-text"}`}>{fmt(weekly.total)}</div>
                <div className="small-muted">{weekly.trades} trades</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default TradingCalendar;